var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Stepper',{attrs:{"text_settings":this.text_settings}})],1),_c('Footer',{attrs:{"text_settings":this.text_settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }